var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9969 14.9748C11.8635 14.9748 11.7385 14.9541 11.6219 14.9128C11.5052 14.8715 11.3969 14.8005 11.2969 14.6998L6.69687 10.0998C6.51354 9.91647 6.42188 9.68314 6.42188 9.3998C6.42188 9.11647 6.51354 8.88314 6.69687 8.6998C6.88021 8.51647 7.11354 8.4248 7.39687 8.4248C7.68021 8.4248 7.91354 8.51647 8.09688 8.6998L11.9969 12.5998L15.8969 8.6998C16.0802 8.51647 16.3135 8.4248 16.5969 8.4248C16.8802 8.4248 17.1135 8.51647 17.2969 8.6998C17.4802 8.88314 17.5719 9.11647 17.5719 9.3998C17.5719 9.68314 17.4802 9.91647 17.2969 10.0998L12.6969 14.6998C12.5969 14.7998 12.4885 14.8708 12.3719 14.9128C12.2552 14.9548 12.1302 14.9755 11.9969 14.9748Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.e577255b1384b184a9d741bfb0a9ce75.svg";
export { ForwardRef as ReactComponent };